import React from "react";
import classnames from "classnames";

import { Uuid } from "@formant/core/model/Uuid";

import { Chip } from "./common/Chip";
import styles from "./DeviceStatus.scss";

export interface IDeviceStatusProps {
    id?: Uuid;
    className?: string;
    online: boolean;
    unprovisioned?: boolean;
}

export function DeviceStatus(props: IDeviceStatusProps) {
    const { className, online, unprovisioned } = props;

    return (
        <Chip
            className={classnames(
                styles.chip,
                online && !unprovisioned && styles.online,
                unprovisioned && styles.unprovisioned,
                className,
            )}
        />
    );
}
